// =============================================================================
// 서비스 워커 메시지 전송 헬퍼 (swMessage)
// 
// [한계 및 유의사항]
// 이 방식은 해당 브라우저의 서비스 워커에만 전달된다. 여러 기기에
// 구독이 걸려 있으면 다른 기기의 배너는 닫히지 않는다. 향후 과제.
// =============================================================================

/**
 * 통화 수락 또는 거절 시 현재 브라우저에 표시된 통화 수신 배너를 닫도록 서비스 워커에 요청
 * - WebRTC 통화 흐름을 방해하지 않도록 동기 함수로 작성되었으며 내부에서 비동기 처리
 * - 어떠한 예외도 외부로 던지지 않도록 전 구역 격리
 * 
 * @param {string} callId - 닫을 통화 세션 ID
 */
export function closeCallNotificationBanner(callId) {
  if (!callId || typeof callId !== 'string' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.active?.postMessage({
          type: 'CLOSE_CALL_NOTIFICATION',
          tag: `call-${callId}`,
        });
      })
      .catch(() => {});
  } catch {
    // 서비스 워커 메시지 전송 실패가 통화 흐름에 영향을 주지 않도록 무시
  }
}

let isBannerClickListenerRegistered = false;
let bannerClickHandler = null;

/**
 * 서비스 워커의 CALL_BANNER_CLICKED 메시지(모드 B) 수신 리스너 등록
 * - 배너 클릭 시 앱 내부에서 직접 window.focus() 를 수행하여 마이크 F8 음소거 회피 시험
 * 
 * @param {Function} [onClicked] - 추가 콜백 (옵션)
 * @returns {Function} cleanup - 등록 해제 함수
 */
export function registerCallBannerClickListener(onClicked) {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return () => {};
  }

  // 중복 등록 방지
  if (isBannerClickListenerRegistered && bannerClickHandler) {
    navigator.serviceWorker.removeEventListener('message', bannerClickHandler);
  }

  bannerClickHandler = (event) => {
    if (event.data && event.data.type === 'CALL_BANNER_CLICKED') {
      try {
        window.focus();
      } catch {
        // 브라우저 포커스 정책으로 실패해도 앱 동작에 영향 없음
      }
      try {
        onClicked?.(event.data);
      } catch {}
    }
  };

  navigator.serviceWorker.addEventListener('message', bannerClickHandler);
  isBannerClickListenerRegistered = true;

  return () => {
    if (bannerClickHandler) {
      navigator.serviceWorker.removeEventListener('message', bannerClickHandler);
      bannerClickHandler = null;
      isBannerClickListenerRegistered = false;
    }
  };
}
